import { useGetOrganizationCrmSystems } from '@/features/organization/hooks/utils/useGetOrganizationCrmSystems/useGetOrganizationCrmSystems';
import { CrmSystemCheckboxSelectSanitizedProps } from '.';
import { CrmSystemCheckbox } from '../../molecules/CrmSystemCheckbox';

export const CrmSystemCheckboxSelectSanitized = ({
    checkedSystemsIds,
    handleCheckboxChange,
    recordsByCrm,
}: CrmSystemCheckboxSelectSanitizedProps) => {
    const items = useGetOrganizationCrmSystems();

    return (
        <div className="flex gap-1">
            {items.map((item) => (
                <CrmSystemCheckbox
                    key={item.id}
                    crmSystem={item}
                    checked={checkedSystemsIds.includes(item.id)}
                    onCheckedChange={(checked) =>
                        handleCheckboxChange(item.id, Boolean(checked))
                    }
                    count={recordsByCrm?.[item.id]}
                />
            ))}
        </div>
    );
};
